(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["page-contact-template"]) return;
  try {
    
$(function () {
  
   $('.wpcf7 .wpcf7-list-item').on('click', function(){
		$(this).addClass('input-active').siblings().removeClass('input-active');
	});
 
});


  } catch(e) { console.error(e); }
})();

})();
